import { Container, Image } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import { Footer } from "./components/Footer";
import React from "react";
import CheckOutWizard from "./CheckOutWizard";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";

export type HotelLandingProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

export type HotelLandingState = {
  showAuthenticationModal?: boolean;
  payload: AuthorizationResponsePayload;
};

export const CheckOut = (props: HotelLandingProps, state: HotelLandingState) => {

  const showLoginDialog = () => {
    if (props.onApply) props.onApply();
  };

  const getPayload = (): AuthorizationResponsePayload => {
    return props.payload ?? state.payload;
  };
  return (
    <Container style={{ maxWidth: "100%", padding: "0px" }}>
      <NavBar />
      <div className="banner-section">
        <div>
          <Image
            style={{
              width: "100%",
            }}
            src={require("./reception.jpg")}
          ></Image>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>
        </div>
        <div className="content-box">
          <h1 data-animation-in="fadeInUp" data-delay-in="0.3">
            Prepare for your departure
          </h1>
          <span
            className="sub-title"
            data-animation-in="fadeInUp"
            data-delay-in="0.1"
          >
            Thank you for your visit! For an easy check-out process, please follow the next steps.
          </span>
          <a
            href="#checkin-wizard"
            className="btn"
            data-animation-in="fadeInUp"
            data-delay-in="0.5"
            style={{ width: "210px" }}
          >
            Check-Out
          </a>
        </div>
      </div>

      <div
        id="checkin-wizard"
        className="pre-check-in-box"
        style={{ margin: "200px 100px 0px 100px" }}
      >
        <CheckOutWizard payload={getPayload()} onApply={() => showLoginDialog()} />
      </div>
      <Footer />
    </Container>
  );
};
